import faker from 'faker';
import { createRange } from '@/utils/helpers';
import { ITariffData } from '../tariff.types';
import { Tariff } from '../tariff';
import { TariffTypeEnum } from '../tariff.constants';
import { createRandomHSCode } from '@/models/hs-code';

export function createRandomTariff(): ITariffData {
  const type = faker.random.arrayElement([
    TariffTypeEnum.Region,
    TariffTypeEnum.Country,
    TariffTypeEnum.HSCode
  ]);

  return {
    id: faker.datatype.number(),
    tariff_type: type,
    destination_country: faker.address.countryCode(),
    tariff_rate: faker.datatype.float({ min: 0 }).toString(),

    origin_country:
      type === TariffTypeEnum.Country ? faker.address.countryCode() : null,
    origin_region:
      type === TariffTypeEnum.Region ? faker.datatype.number() : null,
    hs_code: type === TariffTypeEnum.HSCode ? createRandomHSCode() : null,

    effective_date: faker.date.recent().toISOString(),
    expiration_date: faker.date.soon().toISOString()
  };
}

export const mockTariffsData: ITariffData[] = createRange(3).map(() =>
  createRandomTariff()
);

export const mockTariffs = mockTariffsData.map(tariff => new Tariff(tariff));
